"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingButton = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("../utils");
var StyledButton = (0, styled_components_1.default)(storm_ui_1.Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: ", ";\n"], ["\n  margin: ", ";\n"])), function (_a) {
    var withMargin = _a.withMargin, theme = _a.theme;
    return (withMargin ? theme.spacing.mini : 'unset');
});
var StyledIcon = (0, styled_components_1.default)(storm_ui_1.Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-inline-end: ", ";\n"], ["\n  padding-inline-end: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
var LoadingButton = function (props) {
    var onClickSend = props.onClickSend, isLoading = props.isLoading, isDisabled = props.isDisabled, withMargin = props.withMargin, isSmall = props.isSmall, loadingLabel = props.loadingLabel, sendLabel = props.sendLabel, disabledLabel = props.disabledLabel, secondary = props.secondary;
    var displayedLabel = (function () {
        if (isLoading)
            return loadingLabel;
        if (isDisabled && disabledLabel) {
            return disabledLabel;
        }
        return sendLabel;
    })();
    return (react_1.default.createElement(StyledButton, __assign({}, (0, utils_1.getDataAndAriaProperties)(props), { withMargin: withMargin, small: isSmall, primary: !secondary, onClick: onClickSend, disabled: isDisabled || isLoading }),
        isLoading && react_1.default.createElement(StyledIcon, { type: 'spinner' }),
        displayedLabel));
};
exports.LoadingButton = LoadingButton;
var templateObject_1, templateObject_2;
